import { gql } from "@apollo/client";

export const CREATE_PERFORMANCE = gql`
  mutation createPerformance($input: createPerformanceInput) {
    createPerformance(input: $input) {
      id
    }
  }
`;

export const GET_PERFORMANCE = gql`
  query Performance($userId: String) {
    performance(userId: $userId) {
      id
      templateName
      templateQuestions
      userId
      createdOn
      departmentNames
      projectNames
    }
  }
`;
export const GET_PERFORMANCE_BY_ID = gql`
  query PerformanceById($id: Int) {
    performanceById(id: $id) {
      createdOn
      id
      templateName
      templateQuestions
      userId
      assignPerformance {
        id
        project
        department
        role
        assignedUsers
      }
    }
  }
`;
export const GET_PERFORMANCE_BY_IDS = gql`
  query PerformanceByIds($performanceByIdsId: [Int]) {
    performanceByIds(ids: $performanceByIdsId) {
      id
      templateName
      templateQuestions
      userId
      createdOn
    }
  }
`;
export const UPDATE_PERFORMANCE = gql`
  mutation updatePerformance($input: updatePerformanceInput) {
    updatePerformance(input: $input)
  }
`;

export const ASSIGNED_PERFORMANCE_TEMPLATE = gql`
  query GetAssignedPerformanceTemplate($userId: String) {
    getAssignedPerformanceTemplate(userId: $userId) {
      templateName
      templateQuestions
      id
      createdOn
      userId
      assignedPerformances {
        id
        templateId
        department
        role
        project
        selectPerformance
        startDate
        endDate
        assignedUsers
      }
    }
  }
`;
